"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  notificationTrigger: 'COMPLETION',
  notificationRecipient: 'USERS_AT_ORGANISATION_UNIT'
};
exports.default = _default;
//# sourceMappingURL=programNotificationTemplate.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/d2/model/config/model-defaults/programNotificationTemplate.js
// module id = 1239
// module chunks = 0